import { render } from "./UseItemTreasure.vue?vue&type=template&id=18fe8f00"
import script from "./UseItemTreasure.vue?vue&type=script&lang=js"
export * from "./UseItemTreasure.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/windowOverlay/UseItemTreasure.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18fe8f00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18fe8f00', __exports__)) {
    api.reload('18fe8f00', __exports__)
  }
  
  module.hot.accept("./UseItemTreasure.vue?vue&type=template&id=18fe8f00", () => {
    api.rerender('18fe8f00', render)
  })

}


export default __exports__